export const VIEWPORT_MAX_SIZE = {
  DESKTOP: 2560,
  TABLET: 768,
  MOBILE: 425
};

export const VIEWPORT_MIN_SIZE = {
  DESKTOP: 769,
  TABLET: 426,
  MOBILE: 320
};
